import React from 'react';

/**
 * TRASH ICON SVG ELEMENT
 */
export default function TrashIconSVG(): JSX.Element {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5Z'
        fill='white'
      />
      <path
        d='M16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5Z'
        stroke='#6888B5'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.1595 10.0278V10.3454H10.651C10.4209 10.3454 10.2344 10.532 10.2344 10.7621C10.2344 10.9922 10.4209 11.1788 10.651 11.1788H21.3494C21.5795 11.1788 21.766 10.9922 21.766 10.7621C21.766 10.532 21.5795 10.3454 21.3494 10.3454H18.8408V10.0278C18.8408 9.18401 18.1568 8.5 17.313 8.5H14.6872C13.8435 8.5 13.1595 9.18401 13.1595 10.0278ZM14.6872 9.33333C14.3037 9.33333 13.9928 9.64425 13.9928 10.0278V10.3454H18.0075V10.0278C18.0075 9.64425 17.6966 9.33333 17.313 9.33333H14.6872Z'
        fill='#00245B'
      />
      <path
        d='M17.7832 14.7231C18.0133 14.7231 18.1999 14.9097 18.1999 15.1398V20.1918C18.1999 20.4219 18.0133 20.6085 17.7832 20.6085C17.5531 20.6085 17.3665 20.4219 17.3665 20.1918V15.1398C17.3665 14.9097 17.5531 14.7231 17.7832 14.7231Z'
        fill='#00245B'
      />
      <path
        d='M14.6337 15.1398C14.6337 14.9097 14.4471 14.7231 14.217 14.7231C13.9869 14.7231 13.8003 14.9097 13.8003 15.1398V20.1918C13.8003 20.4219 13.9869 20.6085 14.217 20.6085C14.4471 20.6085 14.6337 20.4219 14.6337 20.1918Z'
        fill='#00245B'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.2709 11.8312C10.6919 11.8312 10.2413 12.3339 10.3044 12.9094L11.3712 22.6337C11.4253 23.1267 11.8418 23.4999 12.3377 23.4999H19.6627C20.1586 23.4999 20.575 23.1267 20.6291 22.6337L21.6959 12.9094C21.7591 12.3339 21.3084 11.8312 20.7295 11.8312H11.2709ZM11.1328 12.8185C11.1238 12.7363 11.1882 12.6645 11.2709 12.6645H20.7295C20.8122 12.6645 20.8766 12.7363 20.8676 12.8185L19.8008 22.5428C19.793 22.6133 19.7336 22.6666 19.6627 22.6666H12.3377C12.2668 22.6666 12.2073 22.6133 12.1996 22.5428L11.1328 12.8185Z'
        fill='#00245B'
      />
    </svg>
  );
}
